function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as constants from '../../../constants';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
var _React_Component;
class DeleteCountryModal extends (_React_Component = React.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.isInProgress && !this.props.isInProgress && !this.props.hasErrors) {
            this.props.onDeleteSuccess();
        }
    }
    renderContent() {
        if (this.props.isDeleteCountryResultSuccess === null) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text--paragraph pr-2",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.deleteCountry), {
                            values: {
                                b: (chunk)=>/*#__PURE__*/ _jsx("b", {
                                        children: chunk
                                    })
                            }
                        }))
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                styleModifier: "primary",
                                labelMessage: App.messages.buttons.cancel,
                                className: "btn--block mr-5",
                                isInProgress: this.props.isInProgress,
                                onClick: ()=>this.props.onClose()
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                styleModifier: "primary",
                                labelMessage: App.messages.buttons.delete,
                                className: "btn--block btn--filled btn--danger",
                                isInProgress: this.props.isInProgress,
                                onClick: ()=>this.props.onDeleteCountry(this.props.country.code)
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.unableToDeleteCountry), {
                        values: {
                            b: (chunk)=>/*#__PURE__*/ _jsx("b", {
                                    children: chunk
                                })
                        }
                    }))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "d-flex",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        styleModifier: "primary",
                        onClick: ()=>this.props.onClose(),
                        labelMessage: App.messages.buttons.close,
                        className: "btn--block btn--filled"
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Modal, {
            modalId: constants.DELETE_COUNTRY_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: this.props.isDeleteCountryResultSuccess ? messages.headers.unableToDeleteCountry : messages.headers.deleteCountry,
            styleModifier: "md",
            isInProgress: this.props.isInProgress,
            onClose: this.props.onClose,
            children: this.renderContent()
        });
    }
}
_define_property(DeleteCountryModal, "propTypes", {
    // Explicit props
    country: PropTypes.object,
    // Explicit actions
    onDeleteSuccess: PropTypes.func,
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    isDeleteCountryResultSuccess: PropTypes.bool,
    openModalId: PropTypes.string,
    // Implicit actions
    onClose: PropTypes.func,
    onDeleteCountry: PropTypes.func
});
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state),
        isInProgress: selectors.isDeleteCountryProgress(state),
        isDeleteCountryResultSuccess: selectors.isDeleteCountryResultSuccess(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onClose: ()=>dispatch(App.actions.closeModal()),
        onDeleteCountry: (countryCode)=>dispatch(actions.deleteCountry(countryCode))
    });
const ConnectedDeleteCountryModal = connect(mapStateToProps, mapDispatchToProps)(DeleteCountryModal);
export default ConnectedDeleteCountryModal;
